import { render, staticRenderFns } from "./VersionBack.vue?vue&type=template&id=5ba47fe0&"
import script from "./VersionBack.vue?vue&type=script&lang=js&"
export * from "./VersionBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports